import { render, staticRenderFns } from "./BrandFields.vue?vue&type=template&id=5ef9e660&scoped=true&"
import script from "./BrandFields.vue?vue&type=script&lang=ts&"
export * from "./BrandFields.vue?vue&type=script&lang=ts&"
import style0 from "./BrandFields.vue?vue&type=style&index=0&id=5ef9e660&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef9e660",
  null
  
)

export default component.exports